// extracted by mini-css-extract-plugin
module.exports = {"containerFullHeight":"Skeleton_containerFullHeight__PH8ul","containerItemsCenter":"Skeleton_containerItemsCenter__35rdc"};